import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
import createDOMPurify from 'dompurify';
var sanitizer = createDOMPurify();
sanitizer.addHook('afterSanitizeAttributes', function (currentNode) {
    if ('target' in currentNode) {
        // Open all links in new tab / window
        currentNode.setAttribute('target', '_blank');
        // To prevent legacy browsers to pass confidential info across the link...
        // https://developer.chrome.com/docs/lighthouse/best-practices/external-anchors-use-rel-noopener
        currentNode.setAttribute('rel', 'noopener noreferrer');
    }
});
export var useGetTaskDocumentation = function (taskTemplateId, enabled) {
    var intl = useIntl();
    var _a = useQuery([TaskQueryKey.TaskDocumentation, taskTemplateId], function () {
        return api.base
            .get("".concat(config.appUrls.tasks, "/api/taskTemplates/Documentation/").concat(taskTemplateId))
            .then(function (_a) {
            var documentation = _a.data;
            return ({
                documentation: sanitizer.sanitize(documentation || ''),
            });
        });
    }, {
        enabled: enabled,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error, refetch = _a.refetch;
    return {
        data: data,
        error: error,
        isLoading: isLoading,
        refetch: refetch,
    };
};
